<div class="container-fluid m-0 p-0" appFitViewport [ngClass]="{ 'dark-theme': isDark, 'light-theme': !isDark }"
  style="overflow: hidden;">
  <!-- Panel flotante de control -->
  <div class="floating-control-panel" (mouseenter)="expandirDiv()" (mouseleave)="contraerDiv()"
    [ngClass]="{'expanded': mouseSobreDiv}">
    <div class="panel-toggle">
      <mat-icon>{{mouseSobreDiv ? 'chevron_left' : 'menu'}}</mat-icon>
    </div>
    <div class="panel-content">
      <h6 class="panel-title mb-2">Paneles</h6>
      <div class="panel-option">
        <mat-checkbox [checked]="cartera" (change)="showTab('cartera')" [color]="'primary'">
          Cartera
        </mat-checkbox>
      </div>
      <div class="panel-option">
        <mat-checkbox [checked]="modeloDiv" (change)="showTab('lista')" [color]="'primary'">
          Lista Mercados
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="row-container p-0 m-0" #rowContainer>
    <div class="col-md-2 p-0 m-0 resizable-column h-100" *ngIf="cartera" #column1 data-key="strategyfactory_col_cartera_v2">
      <div class="resizer" (mousedown)="startResizing($event, column1)" title="Arrastrar para redimensionar"></div>
      <mat-card class="enrolled-created-box ccorbit-card h-100">
        <mat-card-content class="h-100 d-flex flex-column">
              <div class="algo-form">

                <!-- ── MERCADO ── -->
                <div class="algo-section">
                  <div class="oc-section-header">
                    <mat-icon>show_chart</mat-icon>
                    <span>Mercado & Frecuencia</span>
                  </div>
                  <div class="row g-2 algo-section-body">
                    
                    <div class="col-6">
                      <app-mercado-select [mercados]="mercados"
                        [restringirCuentaMetaapi]="true"
                        [(ngModel)]="selectedIdMercado"
                        [disabled]="isLoadingMetaapi"
                        (change)="changeInput('idMercado', $event)">
                      </app-mercado-select>
                    </div>
                    <div class="col-6">
                      <select class="form-select form-select-sm listas" [(ngModel)]="selectedFrecuency" (change)="changeInput('period', $event)">
                        <option *ngFor="let frec of frecuencySelect" [ngValue]="frec.idperiodo">
                          {{frec.periodo}}
                        </option>
                      </select>
                    </div><!-- Progreso descarga MetaAPI — ancho completo -->
                    <div class="col-12" *ngIf="isLoadingMetaapi">
                      <div class="d-flex flex-column gap-1">
                        <small style="color: var(--nec-text-muted)">Descargando {{ candlesDownloadSymbol || 'datos' }} {{ descargaFuente === 'fmp' ? 'FMP' : 'MetaAPI' }}{{ candlesDownloadFase ? ' — ' + faseLabel(candlesDownloadFase) : '' }}...</small>
                        <mat-progress-bar
                          [mode]="candlesDownloadExpected > 0 ? 'determinate' : 'indeterminate'"
                          [value]="candlesDownloadExpected > 0 ? (candlesDownloadTotal / candlesDownloadExpected) * 100 : 0"
                          color="primary" style="border-radius:4px;">
                        </mat-progress-bar>
                        <small *ngIf="candlesDownloadExpected > 0" class="d-block text-center" style="color: var(--nec-text-muted)">
                          {{candlesDownloadTotal | number:'1.0-0'}} / {{candlesDownloadExpected | number:'1.0-0'}} {{ descargaFuente === 'fmp' ? 'activos' : 'velas' }}
                          ({{(candlesDownloadTotal / candlesDownloadExpected) * 100 | number:'1.0-0'}}%)
                        </small>
                      </div>
                    </div>
                    <div class="col-6">
                      <label class="algo-label">Fecha inicial</label>
                      <input type="date" class="form-control form-control-sm ccorbit-input" name="fecha"
                        (change)="changeInput('fechaInicio', $event)" (input)="onFechaInput($event)" (keydown)="onFechaKeydown($event)" [value]="fechaInicial"
                        [min]="fechaMinimaDisponible" [max]="fechaFinal">
                    </div>
                    <div class="col-6">
                      <label class="algo-label">Fecha Final</label>
                      <input type="date" class="form-control form-control-sm ccorbit-input" name="fechaFinal"
                        (change)="changeInput('fechaFinal', $event)" (input)="onFechaInput($event)" (keydown)="onFechaKeydown($event)" [value]="fechaFinal"
                        [min]="fechaInicial" [max]="today">
                    </div>
                    
                    <!-- Aviso broker desconectado — ancho completo -->
                    <div class="col-12" *ngIf="buscarmetaapi(selectedIdMercado) && !metaapiConnected && !isLoadingMetaapi">
                      <div class="d-flex align-items-center gap-2 px-2 py-1 rounded"
                           style="background:rgba(255,160,0,0.12); border:1px solid rgba(255,160,0,0.4)">
                        <mat-icon class="icon-md" style="width:16px;height:16px;color:#ffa000;flex-shrink:0">warning</mat-icon>
                        <small class="txt-sm" style="color:#ffa000; flex:1">Se necesita conectarse al broker para usar datos MetaApi.</small>
                        <button type="button" class="btn btn-warning btn-sm py-0 px-2 txt-sm" style="white-space:nowrap" (click)="openBrokerLogin()">Conectar</button>
                      </div>
                    </div>
                  </div>
                </div>
                
                
                <!-- ── TIPO DE ESTRATEGIA ── -->
                <div class="algo-section">
                  <div class="oc-section-header">
                    <mat-icon>swap_vert</mat-icon>
                    <span>Tipo de estrategia</span>
                  </div>
                  <div class="oc-grid">
                    <label class="oc-label">Dirección</label>
                    <mat-button-toggle-group class="oc-toggle-group" [value]="optimalWallet.bajista ? 'bajista' : 'alcista'"
                      (change)="onTipoEstrategiaChange($event)" [class.custom-toggle-group-light]="!isDark"
                      [class.custom-toggle-group-dark]="isDark">
                      <mat-button-toggle value="alcista">Alcista</mat-button-toggle>
                      <mat-button-toggle value="bajista">Bajista</mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>
                </div>

                <!-- ── CAPITAL & RIESGO (mismas clases oc-* que ModelsComponent) ── -->
                <div class="algo-section">
                  <div class="oc-section-header">
                    <mat-icon>account_balance_wallet</mat-icon>
                    <span>Capital & Riesgo</span>
                  </div>

                  <div class="oc-grid">
                    <label class="oc-label">Capital Inicial (€)</label>
                    <input type="number" id="capitalInicial" class="oc-input" placeholder="100000"
                      [(ngModel)]="capitalInicial" (blur)="capitalInicial = convertirValorNumerico(capitalInicial)"
                      min="0" step="100">

                    <label class="oc-label">Tipo Cuenta</label>
                    <select class="oc-select" (change)="changeInput('tipoCuenta', $event)"
                      [(ngModel)]="tipoCuenta">
                      <option value="MARGEN">MARGEN</option>
                      <option value="NOMINAL">NOMINAL</option>
                    </select>

                    <label class="oc-label">Margen Req. (%)</label>
                    <input type="number" id="margenRequeridoPor" class="oc-input" placeholder="30"
                      [(ngModel)]="margenRequeridoPor"
                      (blur)="margenRequeridoPor = convertirValorNumerico(margenRequeridoPor)"
                      min="0" max="100" step="1">

                    <label class="oc-label">Control M.Call (%)</label>
                    <input type="number" id="controlMarginCall" class="oc-input" placeholder="75"
                      [(ngModel)]="controlMarginCall"
                      (blur)="controlMarginCall = convertirValorNumerico(controlMarginCall)"
                      min="0" max="100" step="1">

                    <label class="oc-label">Riesgo Máximo (%)</label>
                    <input type="number" id="riesgoMaximo" class="oc-input" placeholder="50"
                        [(ngModel)]="riesgoMaximo" (blur)="riesgoMaximo = convertirValorNumerico(riesgoMaximo)"
                        min="0" max="100" step="1">

                    <label class="oc-label">Tipo Riesgo</label>
                    <select class="oc-select" (change)="changeInput('tipoRiesgo', $event)"
                      [(ngModel)]="selectedTipoRiesgo">
                      <option [ngValue]="tipo" *ngFor="let tipo of tiposRiesgo">{{tipo}}</option>
                    </select>


                      <div class="oc-full-row oc-stacked">
                        <label class="oc-label mb-0">Valor Riesgo</label>
                        <div class="input-group">
                          <input type="number" id="valorRiesgo"
                            class="form-control form-control-sm ccorbit-input text-center stop-loss-input"
                            placeholder="100" [(ngModel)]="valorRiesgo" (blur)="onValorRiesgoBlur()" min="0" max="1000" step="100">
                          <input type="number" id="valorRiesgoFinal"
                            class="form-control form-control-sm ccorbit-input text-center stop-loss-input"
                            placeholder="100" [(ngModel)]="valorRiesgoFinal" (blur)="onValorRiesgoFinalBlur()" min="0"
                            max="1000" step="100" [disabled]="!habilitarRangoRiesgo">
                          <input type="number" id="pasoRiesgo"
                            class="form-control form-control-sm ccorbit-input text-center stop-loss-input"
                            placeholder="10" [(ngModel)]="pasoRiesgo" (blur)="onPasoRiesgoBlur()" min="1" max="10000"
                            step="1" [disabled]="!habilitarRangoRiesgo">
                        </div>
                      </div>

                    <hr class="oc-separador">

                    <div class="oc-check-label">
                      <mat-slide-toggle [(ngModel)]="optimalWallet.chkcomisionbroker" color="primary">
                        Comisión 2/2 (€)</mat-slide-toggle>
                    </div>
                    <input type="number" id="comisionBroker" class="oc-input" placeholder="10"
                      [(ngModel)]="optimalWallet.comisionbroker"
                      (blur)="optimalWallet.comisionbroker = convertirValorNumerico(optimalWallet.comisionbroker) ?? 0"
                      [disabled]="!optimalWallet.chkcomisionbroker" min="0" step="0.5">

                    <div class="oc-check-label">
                      <mat-slide-toggle [(ngModel)]="optimalWallet.chkgastogest" color="primary">
                        Gastos Gestión (%)</mat-slide-toggle>
                    </div>
                    <input type="number" id="gastosGestionPor" class="oc-input" placeholder="1"
                      [(ngModel)]="optimalWallet.gastosGestionPor"
                      (blur)="optimalWallet.gastosGestionPor = convertirValorNumerico(optimalWallet.gastosGestionPor) ?? 0"
                      [disabled]="!optimalWallet.chkgastogest" min="0" step="0.5">

                    <div class="oc-check-label">
                      <mat-slide-toggle [(ngModel)]="optimalWallet.chkgastoprest" color="primary">
                        Gastos Préstamo (%)</mat-slide-toggle>
                    </div>
                    <input type="number" id="gastosPrestamoPor" class="oc-input" placeholder="8"
                      [(ngModel)]="optimalWallet.gastosPrestamoPor"
                      (blur)="optimalWallet.gastosPrestamoPor = convertirValorNumerico(optimalWallet.gastosPrestamoPor) ?? 0"
                      [disabled]="!optimalWallet.chkgastoprest" min="0" step="0.5">
                    </div>

                </div>

                <!-- ── OPCIONES ── -->
                <div class="algo-section">
                  <div class="oc-section-header">
                    <mat-icon>tune</mat-icon>
                    <span>Opciones</span>
                  </div>

                  <div class="oc-check-full">
                    <mat-slide-toggle [(ngModel)]="fracciones">Comprar/Vender Fracciones</mat-slide-toggle>
                  </div>

                  <div class="algo-exception-row">
                    <div class="algo-param-row">
                      <mat-slide-toggle [(ngModel)]="combinaciones" color="primary">Combinaciones</mat-slide-toggle>

                      <label class="algo-label mb-0"  *ngIf="combinaciones"> Máx.</label>
                      <input type="number" id="maxcombinaciones" class="form-control form-control-sm ccorbit-input text-center"  *ngIf="combinaciones"
                        style="width:52px;" placeholder="4" [(ngModel)]="maxcombinaciones"
                        (blur)="maxcombinaciones = convertirValorNumerico(maxcombinaciones)" min="0" max="100" step="1">
                    </div>
                  </div>

                  <div class="algo-param-row">
                    <label class="algo-label mb-0" for="minimoOperaciones">Mín. Operaciones</label>
                    <input type="number" id="minimoOperaciones"
                      class="form-control form-control-sm ccorbit-input text-center algo-single-input"
                      placeholder="0" [(ngModel)]="minimoOperaciones"
                      (blur)="minimoOperaciones = convertirValorNumerico(minimoOperaciones)"
                      min="0" step="1">
                  </div>
                </div>
<!-- ── SALIDA DE POSICIÓN ── -->
                <div class="algo-section">
                  <div class="oc-section-header">
                    <mat-icon>trending_down</mat-icon>
                    <span>Condiciones de salida</span>
                  </div>

                  

                  <div class="algo-param-row algo-stoploss-row">
                    <div class="algo-toggle-group">
                      <mat-slide-toggle [ngModel]="stopLoss" (change)="actualizarSlideStoploss($event)">StopLoss</mat-slide-toggle>
                      <mat-slide-toggle [ngModel]="stopLossDinamico"
                        (change)="actualizarSlideStoplossDinamico($event)"
                        [disabled]="!stopLoss">Din.</mat-slide-toggle>
                    </div>
                    <div class="input-group algo-inputs">
                      <input type="number" id="stopLossValue"
                        class="form-control form-control-sm ccorbit-input text-center"
                        (change)="changeInput('stoploss', $event)" (blur)="onStopLossValueBlur()"
                        [(ngModel)]="stopLossValue" min="0">
                      <input type="number" id="stopLossValueFinal"
                        class="form-control form-control-sm ccorbit-input text-center"
                        [(ngModel)]="stopLossValueFinal" (blur)="onStopLossValueFinalBlur()" min="0" max="100" step="1">
                      <input type="number" id="pasoStopLossValue"
                        class="form-control form-control-sm ccorbit-input text-center"
                        [(ngModel)]="pasoStopLossValue" (blur)="onPasoStopLossBlur()" [min]="0.1" [max]="100" [step]="0.1">
                    </div>
                  </div>

                  <div class="algo-param-row">
                    <mat-slide-toggle [ngModel]="proFit" (change)="actualizarSlideProfit($event)">Profit</mat-slide-toggle>
                    <input type="number" class="form-control form-control-sm ccorbit-input text-center algo-single-input"
                      (change)="changeInput('profit', $event)" [(ngModel)]="proFitValue" min="0">
                  </div>

                  <div class="algo-param-row">
                    <mat-slide-toggle [ngModel]="diasSalida" (change)="actualizarSlideDiasSalida($event)">diasSalida</mat-slide-toggle>
                    <input type="number" class="form-control form-control-sm ccorbit-input text-center algo-single-input"
                      (change)="changeInput('diasSalida', $event)" [(ngModel)]="diasSalidaValue" min="0">
                  </div>
                  <div class="algo-param-row">
                    
                    <mat-slide-toggle [(ngModel)]="salidaFinDiaActivo" class="ms-auto">Salida fin de día</mat-slide-toggle>
                  </div>
                </div>
                </div>

              <!-- ── EJECUTAR ── -->
              <div class="algo-execute">
                <div class="algo-warning"
                  *ngIf="(this.selectionTecnicos.selected.length == 0 && this.selectionRatios.selected.length == 0 && this.selectionListas.selected.length == 0) && !loading">
                  <mat-icon>warning_amber</mat-icon>
                  Selecciona condiciones para analizar
                </div>
                <button [disabled]="activatedModelo || (buscarmetaapi(selectedIdMercado) && !metaapiConnected)" mat-flat-button
                  class="ccorbit d-block fw-semibold w-100 algo-run-btn"
                  (click)="buscarAlgoritmo(1, 0, null)">
                  <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
                  <mat-icon class="me-1">{{ loading ? 'stop' : 'play_arrow' }}</mat-icon>
                  {{ loading ? 'Cancelar' : 'Ejecutar' }}
                </button>
                
              </div>

              <!-- ── PROGRESO ── -->
              <div class="algo-progress" *ngIf="notificacion || validas">
                <mat-progress-bar *ngIf="total > 0"
                  [value]="(completadosgeneral / totalgeneral) * 100"
                  color="primary" mode="determinate"
                  style="height: 20px; border-radius: 8px; margin-bottom: 6px;">
                </mat-progress-bar>
                <!-- Total / Procesados / Ocultadas se muestran en el aviso superior del panel de resultados -->
              </div>

              </mat-card-content>
      </mat-card>
    </div>

    <div class="col-md-2 p-0 m-0 resizable-column h-100" *ngIf="modeloDiv" #column1 data-key="strategyfactory_col_modelo">
      <div class="resizer" (mousedown)="startResizing($event, column1)" title="Arrastrar para redimensionar"></div>
      <mat-card class="enrolled-created-box ccorbit-card h-100">
        <mat-card-content class="h-100 d-flex flex-column">
          <div class="indicadores-section">
          <!-- Loading Spinner -->
          <div *ngIf="loadingIndicadoresCondiciones" class="loading-spinner">
            <mat-spinner diameter="40"></mat-spinner>
          </div>

          <!-- Error Message -->
          <div *ngIf="error" class="error-message">
            <mat-error>{{error}}</mat-error>
          </div>

          <!-- Content when data is loaded -->
          <ng-container *ngIf="!loadingIndicadoresCondiciones && !error">
            <!--mat-radio-group [(ngModel)]="selectedType" (change)="onTypeChange($event.value)" class="radio-group">
              <mat-radio-button value="TECNICOS" class="radio-button">
                TECNICOS
              </mat-radio-button>
              <mat-radio-button value="RATIOS" class="radio-button">
                RATIOS
              </mat-radio-button>
            </mat-radio-group-->
            <!-- Condiciones — encima del buscador y la tabla -->
            <div class="indicadores-title">
              <span>INDICADORES & CONDICIONES</span>
            </div>
            <div class="indicadores-toggle-row">
              <mat-button-toggle-group name="stkcfd" aria-label="Font Style" [(ngModel)]="selectedType"
                (change)="onTypeChange($event.value)" class="indicadores-toggle-group"
                [class.custom-toggle-group-light]="!isDark" [class.custom-toggle-group-dark]="isDark">
                <mat-button-toggle value="LISTAS"><mat-icon class="icon-xs" style="height:12px; width:12px; vertical-align:middle; margin-right:2px;">lightbulb</mat-icon>IDEAS</mat-button-toggle>
                <mat-button-toggle value="TECNICOS">TECNICOS</mat-button-toggle>
                <mat-button-toggle value="RATIOS">RATIOS</mat-button-toggle>
                <mat-button-toggle value="PATRONES">PATRONES</mat-button-toggle>
              </mat-button-toggle-group>

              <div class="indicadores-search-toggle" [class.search-open]="indicadoresSearchOpen">
                <button mat-icon-button class="btn-search-toggle" (click)="toggleIndicadoresSearch()" title="Buscar">
                  <mat-icon>search</mat-icon>
                </button>
                <div class="indicadores-search-popover">
                  <input matInput class="indicadores-search-input" (keyup)="applyIndicadoresFilterTecnicos($event)" *ngIf="selectedType === 'TECNICOS'"
                    [(ngModel)]="indicadoresFilterValue" placeholder="Ej. adx" #indicadoresSearchInput (blur)="closeIndicadoresSearchIfEmpty()">
                  <input matInput class="indicadores-search-input" (keyup)="applyIndicadoresFilterRatios($event)" *ngIf="selectedType === 'RATIOS'"
                    [(ngModel)]="indicadoresFilterValue" placeholder="Ej. price" #indicadoresSearchInput (blur)="closeIndicadoresSearchIfEmpty()">
                  <input matInput class="indicadores-search-input" (keyup)="applyIndicadoresFilterListas($event)" *ngIf="selectedType === 'LISTAS'"
                    [(ngModel)]="indicadoresFilterValue" placeholder="Ej. ibex" #indicadoresSearchInput (blur)="closeIndicadoresSearchIfEmpty()">
                  <input matInput class="indicadores-search-input" (keyup)="applyIndicadoresFilterPatrones($event)" *ngIf="selectedType === 'PATRONES'"
                    [(ngModel)]="indicadoresFilterValue" placeholder="Ej. hombro cabeza hombro" #indicadoresSearchInput (blur)="closeIndicadoresSearchIfEmpty()">
                </div>
              </div>
            </div>

            <div class="table-container indicadores-wrapper">
              <cdk-virtual-scroll-viewport *ngIf="selectedType === 'TECNICOS'" [tvsItemSize]="24" [headerHeight]="34"
                class="tvs-viewport tableStyle">
              <table cdk-table [dataSource]="indicadoresDataSourceTecnicos"
                class="table-striped tableStyle">
                <!-- Checkbox Column -->
                <ng-container cdkColumnDef="select">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">
                    <mat-checkbox class="compact-checkbox" (change)="$event.checked ? masterToggleTecnicos() : selectionTecnicos.clear()"
                      [checked]="selectionTecnicos.hasValue() && isAllSelectedTecnicos()"
                      [indeterminate]="selectionTecnicos.hasValue() && !isAllSelectedTecnicos()">
                    </mat-checkbox>
                  </th>
                  <td cdk-cell *cdkCellDef="let row">
                    <mat-checkbox class="compact-checkbox" (click)="$event.stopPropagation()" (change)="toggleSelectionTecnicos(row)"
                      [checked]="selectionTecnicos.isSelected(row)"
                      [indeterminate]="isIndicatorIndeterminate(row, selectedRowTecnico, selectionTecnicos)">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <!-- Counter Column -->

                <ng-container cdkColumnDef="index">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> # </th>
                  <td cdk-cell *cdkCellDef="let element; let i = index" style="position: relative; overflow: visible"> {{i + 1}}
                    <button mat-icon-button class="btn-search-indicator"
                      (click)="$event.stopPropagation(); searchIndicatorInChat(element.label, element.id, true, false);onSelectIndicadorTecnicos(element, false)"
                      title="Buscar en Chat IA">
                      <mat-icon>smart_toy</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <!-- Label Column -->
                <ng-container cdkColumnDef="label">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header" (click)="sortIndicadoresTecnicos('label')">
                    Indicador T
                    <i class="material-icons align-middle ml-1" *ngIf="sortColumnTecnicos === 'label'">
                      {{sortDirectionTecnicos === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
                    </i>
                  </th>
                  <td cdk-cell *cdkCellDef="let element" class="col-label-with-search">

                    <span class="label-text" title="{{element.label}}">{{truncateLabel(element.label)}}</span>
                    <button mat-icon-button class="btn-search-indicator"
                      (click)="$event.stopPropagation(); searchIndicatorInChatGPT(element.label, true);onSelectIndicadorTecnicos(element);"
                      title="Buscar en ChatGPT">
                      <mat-icon>search</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <!-- Action Column (Contador) -->
                <ng-container cdkColumnDef="action">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header" (click)="sortIndicadoresTecnicos('action')">
                    Cont.
                    <i class="material-icons align-middle ml-1" *ngIf="sortColumnTecnicos === 'action'">
                      {{sortDirectionTecnicos === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
                    </i>
                  </th>
                  <td cdk-cell *cdkCellDef="let element"> {{element.action}} </td>
                </ng-container>

                <tr cdk-header-row *cdkHeaderRowDef="['select', 'index', 'label', 'action']; sticky: true"></tr>
                <tr cdk-row *cdkRowDef="let row; columns: ['select', 'index', 'label', 'action'];"
                  (click)="onSelectIndicadorTecnicos(row)" [class.selected-row]="row === selectedRowTecnico"
                  style="cursor: pointer;"></tr>
              </table>
              </cdk-virtual-scroll-viewport>
              <cdk-virtual-scroll-viewport *ngIf="selectedType === 'RATIOS'" [tvsItemSize]="24" [headerHeight]="34"
                class="tvs-viewport tableStyle">
                <table cdk-table [dataSource]="indicadoresDataSourceRatios"
                class="table-striped tableStyle">
                <!-- Checkbox Column -->
                <ng-container cdkColumnDef="select">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">
                    <mat-checkbox class="compact-checkbox" (change)="$event.checked ? masterToggleRatios() : selectionRatios.clear()"
                      [checked]="selectionRatios.hasValue() && isAllSelectedRatios()"
                      [indeterminate]="selectionRatios.hasValue() && !isAllSelectedRatios()">
                    </mat-checkbox>
                  </th>
                  <td cdk-cell *cdkCellDef="let row">
                    <mat-checkbox class="compact-checkbox" (click)="$event.stopPropagation()" (change)="toggleSelectionRatios(row)"
                      [checked]="selectionRatios.isSelected(row)"
                      [indeterminate]="isIndicatorIndeterminate(row, selectedRowRatio, selectionRatios)">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <!-- Counter Column -->

                <ng-container cdkColumnDef="index">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> # </th>
                  <td cdk-cell *cdkCellDef="let element; let i = index" style="position: relative; overflow: visible"> {{i + 1}}
                    <button mat-icon-button class="btn-search-indicator"
                      (click)="$event.stopPropagation(); searchIndicatorInChat(element.label, element.id, false, false);onSelectIndicadorRatios(element, false);"
                      title="Buscar en Chat IA">
                      <mat-icon>smart_toy</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <!-- Label Column -->
                <ng-container cdkColumnDef="label">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header" (click)="sortIndicadoresRatios('label')">
                    Indicador R
                    <i class="material-icons align-middle ml-1" *ngIf="sortColumnRatios === 'label'">
                      {{sortDirectionRatios === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
                    </i>
                  </th>
                  <td cdk-cell *cdkCellDef="let element" class="col-label-with-search">
                    <span class="label-text" title="{{element.label}}">{{truncateLabel(element.label)}}</span>
                    <button mat-icon-button class="btn-search-indicator"
                      (click)="$event.stopPropagation(); searchIndicatorInChatGPT(element.label, false);onSelectIndicadorRatios(element)"
                      title="Buscar en ChatGPT">
                      <mat-icon>search</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <!-- Action Column (Contador) -->
                <ng-container cdkColumnDef="action">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header" (click)="sortIndicadoresRatios('action')">
                    Cont.
                    <i class="material-icons align-middle ml-1" *ngIf="sortColumnRatios === 'action'">
                      {{sortDirectionRatios === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
                    </i>
                  </th>
                  <td cdk-cell *cdkCellDef="let element"> {{element.action}} </td>
                </ng-container>

                <tr cdk-header-row *cdkHeaderRowDef="['select', 'index', 'label', 'action']; sticky: true"></tr>
                <tr cdk-row *cdkRowDef="let row; columns: ['select', 'index', 'label', 'action'];"
                  (click)="onSelectIndicadorRatios(row)" [class.selected-row]="row === selectedRowRatio"
                  style="cursor: pointer;"></tr>
              </table>
              </cdk-virtual-scroll-viewport>
              <cdk-virtual-scroll-viewport *ngIf="selectedType === 'LISTAS'" [tvsItemSize]="24" [headerHeight]="34"
                class="tvs-viewport tableStyle">
                <table cdk-table class="table-listas table-striped tableStyle" [dataSource]="indicadoresDataSourceListas">
                <!-- Checkbox Column -->
                <ng-container cdkColumnDef="select">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">
                    <mat-checkbox class="compact-checkbox" (change)="$event.checked ? masterToggleListas() : selectionListas.clear()"
                      [checked]="selectionListas.hasValue() && isAllSelectedListas()"
                      [indeterminate]="selectionListas.hasValue() && !isAllSelectedListas()">
                    </mat-checkbox>
                  </th>
                  <td cdk-cell *cdkCellDef="let row">
                    <mat-checkbox class="compact-checkbox" (click)="$event.stopPropagation()" (change)="toggleSelectionListas(row)"
                      [checked]="selectionListas.isSelected(row)"
                      [indeterminate]="isIndicatorIndeterminate(row, selectedRowLista, selectionListas)">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <!-- Counter Column -->

                <ng-container cdkColumnDef="index">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> # </th>
                  <td cdk-cell *cdkCellDef="let element; let i = index" style="position: relative; overflow: visible"> {{i + 1}}
                    <button mat-icon-button class="btn-search-indicator"
                      (click)="$event.stopPropagation(); searchIndicatorInChatListas(element.label, element.id); onSelectIndicadorListas(element, false)"
                      title="Buscar en Chat IA">
                      <mat-icon>smart_toy</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <!-- Label Column -->
                <ng-container cdkColumnDef="label">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header" (click)="sortIndicadoresListas('label')">
                    Lista L
                    <i class="material-icons align-middle ml-1" *ngIf="sortColumnListas === 'label'">
                      {{sortDirectionListas === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
                    </i>
                  </th>
                  <td cdk-cell *cdkCellDef="let element"><span class="label-text" title="{{element.label}}">{{truncateLabel(element.label)}}</span></td>
                </ng-container>

                <!-- Action Column (Contador) -->
                <ng-container cdkColumnDef="action">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header" (click)="sortIndicadoresListas('action')">
                    Cont.
                    <i class="material-icons align-middle ml-1" *ngIf="sortColumnListas === 'action'">
                      {{sortDirectionListas === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
                    </i>
                  </th>
                  <td cdk-cell *cdkCellDef="let element" class="action-cell-listas">
                    <span class="action-count">{{element.action}}</span>
                    <button mat-icon-button color="primary" class="btn-delete-lista" (click)="eliminarLista($event, element)"
                      matTooltip="Eliminar Lista">
                      <i class="material-icons">delete</i>
                    </button>
                  </td>
                </ng-container>

                <tr cdk-header-row *cdkHeaderRowDef="['select', 'index', 'label','action']; sticky: true">
                </tr>
                <tr cdk-row *cdkRowDef="let row; columns: ['select', 'index', 'label', 'action'];"
                  (click)="onSelectIndicadorListas(row)" [class.selected-row]="row === selectedRowLista"
                  style="cursor: pointer;"></tr>
              </table>
              </cdk-virtual-scroll-viewport>
              <cdk-virtual-scroll-viewport *ngIf="selectedType === 'PATRONES'" [tvsItemSize]="24" [headerHeight]="34"
                class="tvs-viewport tableStyle">
              <table cdk-table [dataSource]="indicadoresDataSourcePatrones"
                class="table-striped tableStyle">
                <!-- Checkbox Column -->
                <ng-container cdkColumnDef="select">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">
                    <mat-checkbox class="compact-checkbox" (change)="$event.checked ? masterTogglePatrones() : selectionPatrones.clear()"
                      [checked]="selectionPatrones.hasValue() && isAllSelectedPatrones()"
                      [indeterminate]="selectionPatrones.hasValue() && !isAllSelectedPatrones()">
                    </mat-checkbox>
                  </th>
                  <td cdk-cell *cdkCellDef="let row">
                    <mat-checkbox class="compact-checkbox" (click)="$event.stopPropagation()" (change)="toggleSelectionPatrones(row)"
                      [checked]="selectionPatrones.isSelected(row)"
                      [indeterminate]="isIndicatorIndeterminate(row, selectedRowPatron, selectionPatrones)">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <!-- Counter Column -->

                <ng-container cdkColumnDef="index">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> # </th>
                  <td cdk-cell *cdkCellDef="let element; let i = index" style="position: relative; overflow: visible"> {{i + 1}}
                    <button mat-icon-button class="btn-search-indicator"
                      (click)="$event.stopPropagation(); searchIndicatorInChat(element.label, element.id, false, true);onSelectIndicadorPatrones(element, false);"
                      title="Buscar en Chat IA">
                      <mat-icon>smart_toy</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <!-- Label Column -->
                <ng-container cdkColumnDef="label">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header" (click)="sortIndicadoresPatrones('label')">
                    Patrón
                    <i class="material-icons align-middle ml-1" *ngIf="sortColumnPatrones === 'label'">
                      {{sortDirectionPatrones === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
                    </i>
                  </th>
                  <td cdk-cell *cdkCellDef="let element" class="col-label-with-search">
                    <span class="label-text" title="{{element.label}}">{{truncateLabel(element.label)}}</span>
                    <button mat-icon-button class="btn-search-indicator"
                      (click)="$event.stopPropagation(); searchIndicatorInChatGPT(element.label, false, true);onSelectIndicadorPatrones(element);"
                      title="Buscar en ChatGPT">
                      <mat-icon>search</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <!-- Action Column (Contador) -->
                <ng-container cdkColumnDef="action">
                  <th cdk-header-cell *cdkHeaderCellDef class="sticky-header" (click)="sortIndicadoresPatrones('action')">
                    Cont.
                    <i class="material-icons align-middle ml-1" *ngIf="sortColumnPatrones === 'action'">
                      {{sortDirectionPatrones === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
                    </i>
                  </th>
                  <td cdk-cell *cdkCellDef="let element"> {{element.action}} </td>
                </ng-container>

                <tr cdk-header-row *cdkHeaderRowDef="['select', 'index', 'label', 'action']; sticky: true"></tr>
                <tr cdk-row *cdkRowDef="let row; columns: ['select', 'index', 'label', 'action'];"
                  (click)="onSelectIndicadorPatrones(row)" [class.selected-row]="row === selectedRowPatron"
                  style="cursor: pointer;"></tr>
              </table>
              </cdk-virtual-scroll-viewport>

            </div>
          </ng-container>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="p-0 m-0 h-100 main-results-column" [ngClass]="{
      'col-12': !cartera && !modeloDiv,
      'col-10': (cartera && !modeloDiv) || (!cartera && modeloDiv),
      'col-8': cartera && modeloDiv
    }">
      <mat-card class="enrolled-created-box no-scrollbar ccorbit-card h-100">
        <mat-card-content class="h-100 d-flex flex-column">
          <div class="row mb-3">
            <div class="col-12">
              <div class="alert alert-info mb-0 small aviso-ejecucion"
                *ngIf="notificacion || total > 0 || descartadasPorOperaciones > 0">
                <span class="aviso-texto" *ngIf="notificacion">
                  <i class="material-icons align-middle mr-2">info</i>
                  {{notificacion}}
                </span>
                <span class="aviso-stats">
                  <span *ngIf="total > 0" class="fw-semibold">Total: {{totalgeneral}}, Procesados: {{completadosgeneral}}</span>
                  <span *ngIf="descartadasPorOperaciones > 0" class="aviso-ocultadas">
                    Ocultadas por Mín. Operaciones: {{descartadasPorOperaciones}}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <mat-tab-group mat-stretch-tabs="false" [selectedIndex]="selectedTab"
            (selectedTabChange)="onTabChange($event)" mat-align-tabs="start" animationDuration="0ms"
            [preserveContent]="true">
            <mat-tab>
              <ng-template mat-tab-label>
                {{tabTitles[0]}}
                <mat-icon class="tab-help-icon" (click)="showTabHelp(tabTitles[0], $event)"
                  matTooltip="Ayuda">help_outline</mat-icon>
              </ng-template>
              <app-strategy-factory-results-table [tabId]="100" [data]="results?.topResults || []" [enableContextMenu]="true"
                [contextSource]="'main'" [showModelMeetsCriteria]="true" [capitalInicial]="capitalInicial"
                [valorRiesgo]="valorRiesgo" [tipoCuenta]="tipoCuenta" [margenRequeridoPor]="margenRequeridoPor"
                [controlMarginCall]="controlMarginCall" [riesgoMaximo]="riesgoMaximo" [comisionBroker]="optimalWallet.comisionbroker" [gastosGestionPor]="optimalWallet.gastosGestionPor" [gastosPrestamoPor]="optimalWallet.gastosPrestamoPor" [chkComisionBroker]="optimalWallet.chkcomisionbroker" [chkGastoGest]="optimalWallet.chkgastogest" [chkGastoPrest]="optimalWallet.chkgastoprest" [selectedRow]="selectedResult" [enableSelection]="true"
                [selection]="selectionReevaluar" [height]="'100%'" (selectionChange)="actualizarSeleccionReevaluar()"
                (rowContextMenu)="onContextMenu($event.event, $event.row, $event.source)">
              </app-strategy-factory-results-table>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                Mejoras
                <mat-icon class="tab-help-icon" (click)="showTabHelp('Mejoras', $event)" matTooltip="Ayuda">help_outline</mat-icon>
              </ng-template>
              <mat-tab-group [(selectedIndex)]="selectedMejorasSubtab" mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms" [preserveContent]="true" (selectedTabChange)="onMejorasSubtabChange($event)">
                <mat-tab>
                  <ng-template mat-tab-label>
                    Mejora 1
                    <mat-icon class="tab-help-icon" (click)="showTabHelp('Mejora 1', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                  </ng-template>
                  <div class="rt-fixed-table rt-fixed-table--single" #mejora1Top
                    [style.flex]="flexTablaSup('mejora1')"
                    [style.height.px]="altoTablaSupPx('mejora1')"
                    [class.rt-plegada]="tablaPlegada['mejora1:sup']" [class.rt-expandida]="tablaPlegada['mejora1:inf'] && !tablaPlegada['mejora1:sup']">
                    <app-strategy-factory-results-table #mejora1A [plegable]="true" [plegada]="!!tablaPlegada['mejora1:sup']"
                      (plegadaChange)="setTablaPlegada('mejora1:sup', $event, mejora1B)"
                      [title]="'Modelo seleccionado para Optimizacion'" [data]="results.seleccionado || []"
                      [enableContextMenu]="false" [showModelMeetsCriteria]="true" [capitalInicial]="capitalInicial"
                      [valorRiesgo]="valorRiesgo" [tipoCuenta]="tipoCuenta" [margenRequeridoPor]="margenRequeridoPor"
                      [controlMarginCall]="controlMarginCall" [riesgoMaximo]="riesgoMaximo" [comisionBroker]="optimalWallet.comisionbroker" [gastosGestionPor]="optimalWallet.gastosGestionPor" [gastosPrestamoPor]="optimalWallet.gastosPrestamoPor" [chkComisionBroker]="optimalWallet.chkcomisionbroker" [chkGastoGest]="optimalWallet.chkgastogest" [chkGastoPrest]="optimalWallet.chkgastoprest">
                      <button rtTitleActions mat-flat-button color="primary" class="ccorbit fw-semibold algo-run-btn" *ngIf="results.seleccionado && results.seleccionado.length > 0" [disabled]="loading"
                        (click)="optimizarCondicion(results.seleccionado[0], 1, true)">
                        <mat-icon class="me-1">{{ loadingOptimizacion ? 'stop' : 'play_arrow' }}</mat-icon>
                        {{ loadingOptimizacion ? 'Cancelar' : 'Ejecutar' }}
                      </button>
                    </app-strategy-factory-results-table>
                  </div>


                  <div class="split-handle" *ngIf="!tablaPlegada['mejora1:sup'] && !tablaPlegada['mejora1:inf']" matTooltip="Arrastrar para cambiar el alto (doble clic: restaurar)"
                    (mousedown)="iniciarResizeTabla($event, 'mejora1', mejora1Top, [mejora1A, mejora1B])"
                    (dblclick)="resetAltoTabla('mejora1', [mejora1A, mejora1B])"></div>
                  <div class="rt-grow-table" [class.rt-plegada]="tablaPlegada['mejora1:inf']">
                    <app-strategy-factory-results-table #mejora1B [plegable]="true" [plegada]="!!tablaPlegada['mejora1:inf']"
                      (plegadaChange)="setTablaPlegada('mejora1:inf', $event, mejora1A)" [tabId]="200" [title]="'Resultados del Optimizacion 1A'"
                      [data]="results.topResultsOptimizado || []" [enableContextMenu]="true" [contextSource]="'optimized'"
                      [capitalInicial]="capitalInicial" [valorRiesgo]="valorRiesgo" [tipoCuenta]="tipoCuenta"
                      [margenRequeridoPor]="margenRequeridoPor" [controlMarginCall]="controlMarginCall"
                      [riesgoMaximo]="riesgoMaximo" [comisionBroker]="optimalWallet.comisionbroker" [gastosGestionPor]="optimalWallet.gastosGestionPor" [gastosPrestamoPor]="optimalWallet.gastosPrestamoPor" [chkComisionBroker]="optimalWallet.chkcomisionbroker" [chkGastoGest]="optimalWallet.chkgastogest" [chkGastoPrest]="optimalWallet.chkgastoprest" [enableSelection]="true"
                      [selection]="selectionReevaluar" (selectionChange)="actualizarSeleccionReevaluar()"
                      (rowContextMenu)="onContextMenu($event.event, $event.row, $event.source)">
                    </app-strategy-factory-results-table>
                  </div>
                </mat-tab>

                <mat-tab>
                  <ng-template mat-tab-label>
                    Mejora 2
                    <mat-icon class="tab-help-icon" (click)="showTabHelp('Mejora 2', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                  </ng-template>
                  <div class="rt-fixed-table rt-fixed-table--single" #mejora2Top
                    [style.flex]="flexTablaSup('mejora2')"
                    [style.height.px]="altoTablaSupPx('mejora2')"
                    [class.rt-plegada]="tablaPlegada['mejora2:sup']" [class.rt-expandida]="tablaPlegada['mejora2:inf'] && !tablaPlegada['mejora2:sup']">
                    <app-strategy-factory-results-table #mejora2A [plegable]="true" [plegada]="!!tablaPlegada['mejora2:sup']"
                      (plegadaChange)="setTablaPlegada('mejora2:sup', $event, mejora2B)"
                      [title]="'Modelo seleccionado para Optimizacion'" [data]="results.seleccionado2 || []"
                      [enableContextMenu]="false" [showModelMeetsCriteria]="true" [capitalInicial]="capitalInicial"
                      [valorRiesgo]="valorRiesgo" [tipoCuenta]="tipoCuenta" [margenRequeridoPor]="margenRequeridoPor"
                      [controlMarginCall]="controlMarginCall" [riesgoMaximo]="riesgoMaximo" [comisionBroker]="optimalWallet.comisionbroker" [gastosGestionPor]="optimalWallet.gastosGestionPor" [gastosPrestamoPor]="optimalWallet.gastosPrestamoPor" [chkComisionBroker]="optimalWallet.chkcomisionbroker" [chkGastoGest]="optimalWallet.chkgastogest" [chkGastoPrest]="optimalWallet.chkgastoprest">
                      <button rtTitleActions mat-flat-button color="primary" class="ccorbit fw-semibold algo-run-btn" *ngIf="results.seleccionado2 && results.seleccionado2.length > 0" [disabled]="loading"
                        (click)="optimizarCondicion(results.seleccionado2[0], 1, true)">
                        <mat-icon class="me-1">{{ loadingOptimizacion ? 'stop' : 'play_arrow' }}</mat-icon>
                        {{ loadingOptimizacion ? 'Cancelar' : 'Ejecutar' }}
                      </button>
                    </app-strategy-factory-results-table>
                  </div>
                  <div class="split-handle" *ngIf="!tablaPlegada['mejora2:sup'] && !tablaPlegada['mejora2:inf']" matTooltip="Arrastrar para cambiar el alto (doble clic: restaurar)"
                    (mousedown)="iniciarResizeTabla($event, 'mejora2', mejora2Top, [mejora2A, mejora2B])"
                    (dblclick)="resetAltoTabla('mejora2', [mejora2A, mejora2B])"></div>
                  <div class="rt-grow-table" [class.rt-plegada]="tablaPlegada['mejora2:inf']">
                    <app-strategy-factory-results-table #mejora2B [plegable]="true" [plegada]="!!tablaPlegada['mejora2:inf']"
                      (plegadaChange)="setTablaPlegada('mejora2:inf', $event, mejora2A)" [tabId]="201" [title]="'Resultados del Optimizacion xd'"
                      [data]="results.topResultsOptimizado2 || []" [enableContextMenu]="true" [contextSource]="'optimized2'"
                      [capitalInicial]="capitalInicial" [valorRiesgo]="valorRiesgo" [tipoCuenta]="tipoCuenta"
                      [margenRequeridoPor]="margenRequeridoPor" [controlMarginCall]="controlMarginCall"
                      [riesgoMaximo]="riesgoMaximo" [comisionBroker]="optimalWallet.comisionbroker" [gastosGestionPor]="optimalWallet.gastosGestionPor" [gastosPrestamoPor]="optimalWallet.gastosPrestamoPor" [chkComisionBroker]="optimalWallet.chkcomisionbroker" [chkGastoGest]="optimalWallet.chkgastogest" [chkGastoPrest]="optimalWallet.chkgastoprest" [enableSelection]="true"
                      [selection]="selectionReevaluar" (selectionChange)="actualizarSeleccionReevaluar()"
                      (rowContextMenu)="onContextMenu($event.event, $event.row, $event.source)">
                    </app-strategy-factory-results-table>
                  </div>
                </mat-tab>

                <mat-tab>
                  <ng-template mat-tab-label>
                    Mejora 3
                    <mat-icon class="tab-help-icon" (click)="showTabHelp('Mejora 3', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                  </ng-template>
                  <div class="rt-fixed-table rt-fixed-table--single" #mejora3Top
                    [style.flex]="flexTablaSup('mejora3')"
                    [style.height.px]="altoTablaSupPx('mejora3')"
                    [class.rt-plegada]="tablaPlegada['mejora3:sup']" [class.rt-expandida]="tablaPlegada['mejora3:inf'] && !tablaPlegada['mejora3:sup']">
                    <app-strategy-factory-results-table #mejora3A [plegable]="true" [plegada]="!!tablaPlegada['mejora3:sup']"
                      (plegadaChange)="setTablaPlegada('mejora3:sup', $event, mejora3B)" [title]="'Modelo seleccionado para Optimizacion'"
                      [data]="results.seleccionado3 || []" [enableContextMenu]="false"
                      [showModelMeetsCriteria]="true" [capitalInicial]="capitalInicial" [valorRiesgo]="valorRiesgo"
                      [tipoCuenta]="tipoCuenta" [margenRequeridoPor]="margenRequeridoPor"
                      [controlMarginCall]="controlMarginCall" [riesgoMaximo]="riesgoMaximo" [comisionBroker]="optimalWallet.comisionbroker" [gastosGestionPor]="optimalWallet.gastosGestionPor" [gastosPrestamoPor]="optimalWallet.gastosPrestamoPor" [chkComisionBroker]="optimalWallet.chkcomisionbroker" [chkGastoGest]="optimalWallet.chkgastogest" [chkGastoPrest]="optimalWallet.chkgastoprest">
                      <button rtTitleActions mat-flat-button color="primary" class="ccorbit fw-semibold algo-run-btn" *ngIf="results.seleccionado3 && results.seleccionado3.length > 0" [disabled]="loading"
                        (click)="optimizarCondicion(results.seleccionado3[0], 1, true)">
                        <mat-icon class="me-1">{{ loadingOptimizacion ? 'stop' : 'play_arrow' }}</mat-icon>
                        {{ loadingOptimizacion ? 'Cancelar' : 'Ejecutar' }}
                      </button>
                    </app-strategy-factory-results-table>
                  </div>
                  <div class="split-handle" *ngIf="!tablaPlegada['mejora3:sup'] && !tablaPlegada['mejora3:inf']" matTooltip="Arrastrar para cambiar el alto (doble clic: restaurar)"
                    (mousedown)="iniciarResizeTabla($event, 'mejora3', mejora3Top, [mejora3A, mejora3B])"
                    (dblclick)="resetAltoTabla('mejora3', [mejora3A, mejora3B])"></div>
                  <div class="rt-grow-table" [class.rt-plegada]="tablaPlegada['mejora3:inf']">
                    <app-strategy-factory-results-table #mejora3B [plegable]="true" [plegada]="!!tablaPlegada['mejora3:inf']"
                      (plegadaChange)="setTablaPlegada('mejora3:inf', $event, mejora3A)" [tabId]="202" [title]="'Resultados del Optimizacion 2A'"
                      [data]="results.topResultsOptimizado3 || []" [enableContextMenu]="true" [contextSource]="'optimized3'"
                      [capitalInicial]="capitalInicial" [valorRiesgo]="valorRiesgo" [tipoCuenta]="tipoCuenta"
                      [margenRequeridoPor]="margenRequeridoPor" [controlMarginCall]="controlMarginCall"
                      [riesgoMaximo]="riesgoMaximo" [comisionBroker]="optimalWallet.comisionbroker" [gastosGestionPor]="optimalWallet.gastosGestionPor" [gastosPrestamoPor]="optimalWallet.gastosPrestamoPor" [chkComisionBroker]="optimalWallet.chkcomisionbroker" [chkGastoGest]="optimalWallet.chkgastogest" [chkGastoPrest]="optimalWallet.chkgastoprest" [enableSelection]="true"
                      [selection]="selectionReevaluar" (selectionChange)="actualizarSeleccionReevaluar()"
                      (rowContextMenu)="onContextMenu($event.event, $event.row, $event.source)">
                    </app-strategy-factory-results-table>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                {{tabTitles[2]}}
                <mat-icon class="tab-help-icon" (click)="showTabHelp(tabTitles[2], $event)"
                  matTooltip="Ayuda">help_outline</mat-icon>
              </ng-template>

              <div class="rt-fixed-table rt-fixed-table--single" #optimizarTop
                    [style.flex]="flexTablaSup('optimizar')"
                    [style.height.px]="altoTablaSupPx('optimizar')"
                    [class.rt-plegada]="tablaPlegada['optimizar:sup']" [class.rt-expandida]="tablaPlegada['optimizar:inf'] && !tablaPlegada['optimizar:sup']">
                <app-strategy-factory-results-table #optimizarA [plegable]="true" [plegada]="!!tablaPlegada['optimizar:sup']"
                      (plegadaChange)="setTablaPlegada('optimizar:sup', $event, tablaOptimizacion24)"
                  [title]="'Modelo seleccionado para Optimizacion'" [data]="results.seleccionado4 || []"
                  [enableContextMenu]="false" [showModelMeetsCriteria]="true" [capitalInicial]="capitalInicial"
                  [valorRiesgo]="valorRiesgo" [tipoCuenta]="tipoCuenta" [margenRequeridoPor]="margenRequeridoPor"
                  [controlMarginCall]="controlMarginCall" [riesgoMaximo]="riesgoMaximo" [comisionBroker]="optimalWallet.comisionbroker" [gastosGestionPor]="optimalWallet.gastosGestionPor" [gastosPrestamoPor]="optimalWallet.gastosPrestamoPor" [chkComisionBroker]="optimalWallet.chkcomisionbroker" [chkGastoGest]="optimalWallet.chkgastogest" [chkGastoPrest]="optimalWallet.chkgastoprest">
                  <button rtTitleActions mat-flat-button color="primary" class="ccorbit fw-semibold algo-run-btn"
                    *ngIf="optimizarCondicionData && results.seleccionado4 && results.seleccionado4.length > 0" [disabled]="loading"
                    (click)="loadingOptimizacion ? buscarAlgoritmo(3, 0, results.seleccionado4[0]) : mostrareditordeparametros(results.seleccionado4[0])">
                    <mat-icon class="me-1">{{ loadingOptimizacion ? 'stop' : 'refresh' }}</mat-icon>
                    {{ loadingOptimizacion ? 'Cancelar' : 'Reoptimizar' }}
                  </button>
                </app-strategy-factory-results-table>
              </div>

              <div class="split-handle" *ngIf="!tablaPlegada['optimizar:sup'] && !tablaPlegada['optimizar:inf']" matTooltip="Arrastrar para cambiar el alto (doble clic: restaurar)"
                (mousedown)="iniciarResizeTabla($event, 'optimizar', optimizarTop, [optimizarA, tablaOptimizacion24])"
                (dblclick)="resetAltoTabla('optimizar', [optimizarA, tablaOptimizacion24])"></div>

              <!-- Parámetros seleccionados desde Editar Parámetros -->
              <div class="mt-3" *ngIf="optimizarCondicionData">
                <div class="card-header bg-white d-flex align-items-center justify-content-between border-0">
                  <h5 class="mb-0 text-primary d-flex align-items-center" style="cursor: pointer;"
                    (click)="showParametrosSeleccionados = !showParametrosSeleccionados">
                    <mat-icon class="me-2">{{ showParametrosSeleccionados ? 'expand_less' : 'expand_more' }}</mat-icon>
                    <i class="material-icons align-middle mr-2">tune</i>
                    Parámetros seleccionados
                  </h5>
                </div>
                <div class="p-3 border rounded" *ngIf="showParametrosSeleccionados">
                  <div class="row g-3">
                    <div class="mb-2">
                      <strong>Condicion:</strong>
                      <code class="d-block"
                        style="max-height:72px; overflow:auto; white-space: pre;">{{ optimizarCondicionData?.template }}</code>
                    </div>
                    <div class="col-md-6">

                      <div class="mb-2" *ngIf="optimizarCondicionData?.params?.length">
                        <strong>Parámetros ({{ optimizarCondicionData.params.length }}):</strong>
                        <table class="w-100 txt-base" style="border-collapse: collapse;">
                          <thead>
                            <tr>
                              <th style="text-align:left; padding:4px 8px; border-bottom:1px solid #e0e0e0;">Token</th>
                              <th style="text-align:left; padding:4px 8px; border-bottom:1px solid #e0e0e0;">Inicio</th>
                              <th style="text-align:left; padding:4px 8px; border-bottom:1px solid #e0e0e0;">Final</th>
                              <th style="text-align:left; padding:4px 8px; border-bottom:1px solid #e0e0e0;">Paso</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let p of optimizarCondicionData.params">
                              <td style="padding:4px 8px;">{{ '{{p' + p.id + '}}' }}</td>
                              <td style="padding:4px 8px;">{{ p.start }}</td>
                              <td style="padding:4px 8px;">{{ p.end }}</td>
                              <td style="padding:4px 8px;">{{ p.step }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-2">
                        <strong>Rangos adicionales:</strong>
                        <div class="mt-1" *ngIf="optimizarCondicionData?.stopLossRange">
                          Stop Loss → Orig: {{ optimizarCondicionData.stopLossRange.original }},
                          Inicio: {{ optimizarCondicionData.stopLossRange.start }},
                          Final: {{ optimizarCondicionData.stopLossRange.end }},
                          Paso: {{ optimizarCondicionData.stopLossRange.step }}
                        </div>
                        <div class="mt-1" *ngIf="optimizarCondicionData?.profitRange">
                          Profit → Orig: {{ optimizarCondicionData.profitRange.original }},
                          Inicio: {{ optimizarCondicionData.profitRange.start }},
                          Final: {{ optimizarCondicionData.profitRange.end }},
                          Paso: {{ optimizarCondicionData.profitRange.step }}
                        </div>
                        <div class="mt-1" *ngIf="optimizarCondicionData?.diasSalidaRange">
                          Días Salida → Orig: {{ optimizarCondicionData.diasSalidaRange.original }},
                          Inicio: {{ optimizarCondicionData.diasSalidaRange.start }},
                          Final: {{ optimizarCondicionData.diasSalidaRange.end }},
                          Paso: {{ optimizarCondicionData.diasSalidaRange.step }}
                        </div>
                        <div class="mt-1" *ngIf="optimizarCondicionData?.riesgoRange">
                          Riesgo → Orig: {{ optimizarCondicionData.riesgoRange.original }},
                          Inicio: {{ optimizarCondicionData.riesgoRange.start }},
                          Final: {{ optimizarCondicionData.riesgoRange.end }},
                          Paso: {{ optimizarCondicionData.riesgoRange.step }}
                        </div>
                      </div>
                      <div class="mb-0">
                        <strong>Total combinaciones:</strong> {{ optimizarCondicionData?.combinations | number }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="rt-grow-table" [class.rt-plegada]="tablaPlegada['optimizar:inf']">
                <app-strategy-factory-results-table #tablaOptimizacion24 [plegable]="true" [plegada]="!!tablaPlegada['optimizar:inf']"
                      (plegadaChange)="setTablaPlegada('optimizar:inf', $event, optimizarA)" [tabId]="203" [title]="'Resultados de Optimizacion'"
                  [data]="results.topResultsOptimizado4 || []" [enableContextMenu]="true" [contextSource]="'optimized3'"
                  [capitalInicial]="capitalInicial" [valorRiesgo]="valorRiesgo" [tipoCuenta]="tipoCuenta"
                  [margenRequeridoPor]="margenRequeridoPor" [controlMarginCall]="controlMarginCall"
                  [riesgoMaximo]="riesgoMaximo" [comisionBroker]="optimalWallet.comisionbroker" [gastosGestionPor]="optimalWallet.gastosGestionPor" [gastosPrestamoPor]="optimalWallet.gastosPrestamoPor" [chkComisionBroker]="optimalWallet.chkcomisionbroker" [chkGastoGest]="optimalWallet.chkgastogest" [chkGastoPrest]="optimalWallet.chkgastoprest" [enableSelection]="true"
                  [selection]="selectionReevaluar" (selectionChange)="actualizarSeleccionReevaluar()"
                  (rowContextMenu)="onContextMenu($event.event, $event.row, $event.source)">
                </app-strategy-factory-results-table>
              </div>


            </mat-tab>

            <mat-tab [disabled]="modelosSeleccionadosReevaluar.length === 0">
              <ng-template mat-tab-label>
                {{tabTitles[3]}}
                <mat-icon class="tab-help-icon" (click)="showTabHelp(tabTitles[3], $event)"
                  matTooltip="Ayuda">help_outline</mat-icon>
              </ng-template>
              <div class="rt-fixed-table" #reevaluarTop
                    [style.flex]="flexTablaSup('reevaluar')"
                    [style.height.px]="altoTablaSupPx('reevaluar')"
                    [class.rt-plegada]="tablaPlegada['reevaluar:sup']" [class.rt-expandida]="tablaPlegada['reevaluar:inf'] && !tablaPlegada['reevaluar:sup']">
                <app-strategy-factory-results-table #tablaModelosSeleccionados [plegable]="true" [plegada]="!!tablaPlegada['reevaluar:sup']"
                      (plegadaChange)="setTablaPlegada('reevaluar:sup', $event, reevaluarB)"
                  [title]="'Modelos seleccionados (' + modelosSeleccionadosReevaluar.length + ')'"
                  [data]="modelosSeleccionadosReevaluar || []" [enableContextMenu]="false" [showModelMeetsCriteria]="true"
                  [showMatchColumn]="true" [matchIdFn]="getReevalMatchId.bind(this)" [capitalInicial]="capitalInicial"
                  [valorRiesgo]="valorRiesgo" [tipoCuenta]="tipoCuenta" [margenRequeridoPor]="margenRequeridoPor"
                  [controlMarginCall]="controlMarginCall" [riesgoMaximo]="riesgoMaximo" [comisionBroker]="optimalWallet.comisionbroker" [gastosGestionPor]="optimalWallet.gastosGestionPor" [gastosPrestamoPor]="optimalWallet.gastosPrestamoPor" [chkComisionBroker]="optimalWallet.chkcomisionbroker" [chkGastoGest]="optimalWallet.chkgastogest" [chkGastoPrest]="optimalWallet.chkgastoprest">
                  <ng-container ngProjectAs="[rtTitleActions]">
                    <label class="reeval-fecha" for="fechaInicialReevaluar" matTooltip="Fecha inicial para la reevaluación">
                      Desde
                      <input type="date" id="fechaInicialReevaluar"
                        class="form-control form-control-sm ccorbit-input text-center" [(ngModel)]="fechaInicialReevaluar"
                        (change)="onFechaInicialReevaluarChange()" (input)="onFechaInicialReevaluarInput()" (keydown)="onFechaReevaluarKeydown($event)"
                        [min]="fechaMinimaDisponible" [max]="fechaFinalReevaluar">
                    </label>
                    <label class="reeval-fecha" for="fechaFinalReevaluar">
                      Hasta
                      <input type="date" id="fechaFinalReevaluar"
                        class="form-control form-control-sm ccorbit-input text-center" [(ngModel)]="fechaFinalReevaluar"
                        (change)="onFechaFinalReevaluarChange()" (input)="onFechaFinalReevaluarInput()" (keydown)="onFechaReevaluarKeydown($event)"
                        [min]="fechaInicialReevaluar" [max]="today">
                    </label>
                    <button [disabled]="modelosSeleccionadosReevaluar.length === 0 || loadingReevaluar" mat-flat-button
                      class="ccorbit fw-semibold algo-run-btn" (click)="clearSelectionReevaluar()">
                      <mat-icon class="me-1">clear_all</mat-icon>
                      Limpiar ({{ modelosSeleccionadosReevaluar.length }})
                    </button>
                    <button [disabled]="modelosSeleccionadosReevaluar.length === 0" mat-flat-button
                      class="ccorbit fw-semibold algo-run-btn" (click)="reevaluarModelos()">
                      <mat-icon class="me-1">{{ loadingReevaluar ? 'stop' : 'refresh' }}</mat-icon>
                      {{ loadingReevaluar ? 'Cancelar' : 'Reevaluar Modelos (' + modelosSeleccionadosReevaluar.length + ')' }}
                    </button>
                  </ng-container>
                </app-strategy-factory-results-table>
              </div>

              <div class="split-handle" *ngIf="!tablaPlegada['reevaluar:sup'] && !tablaPlegada['reevaluar:inf']" matTooltip="Arrastrar para cambiar el alto (doble clic: restaurar)"
                (mousedown)="iniciarResizeTabla($event, 'reevaluar', reevaluarTop, [tablaModelosSeleccionados, reevaluarB])"
                (dblclick)="resetAltoTabla('reevaluar', [tablaModelosSeleccionados, reevaluarB])"></div>
              <div class="rt-grow-table" [class.rt-plegada]="tablaPlegada['reevaluar:inf']">
                <app-strategy-factory-results-table #reevaluarB [plegable]="true" [plegada]="!!tablaPlegada['reevaluar:inf']"
                      (plegadaChange)="setTablaPlegada('reevaluar:inf', $event, tablaModelosSeleccionados)" [tabId]="300" [title]="'Resultados de Reevaluación'"
                  [data]="results.topResultsReevaluacion || []" [enableContextMenu]="true" [contextSource]="'reevaluacion'"
                  [showMatchColumn]="true" [matchIdFn]="getReevalMatchId.bind(this)" [capitalInicial]="capitalInicial"
                  [valorRiesgo]="valorRiesgo" [tipoCuenta]="tipoCuenta" [margenRequeridoPor]="margenRequeridoPor"
                  [controlMarginCall]="controlMarginCall" [riesgoMaximo]="riesgoMaximo" [comisionBroker]="optimalWallet.comisionbroker" [gastosGestionPor]="optimalWallet.gastosGestionPor" [gastosPrestamoPor]="optimalWallet.gastosPrestamoPor" [chkComisionBroker]="optimalWallet.chkcomisionbroker" [chkGastoGest]="optimalWallet.chkgastogest" [chkGastoPrest]="optimalWallet.chkgastoprest"
                  (rowContextMenu)="onContextMenu($event.event, $event.row, $event.source)">
                </app-strategy-factory-results-table>
              </div>



            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                {{tabTitles[4]}}
                <mat-icon class="tab-help-icon" (click)="showTabHelp(tabTitles[4], $event)"
                  matTooltip="Ayuda">help_outline</mat-icon>
              </ng-template>
              <div style="position:relative;">
              <div class="indicadores-search-toggle search-toggle-overlay" [class.search-open]="condicionesSearchOpen">
                <button mat-icon-button class="btn-search-toggle" (click)="toggleCondicionesSearch()" title="Buscar">
                  <mat-icon>search</mat-icon>
                </button>
                <div class="indicadores-search-popover">
                  <input matInput class="indicadores-search-input" (keyup)="applyCondicionesFilter($event)" [(ngModel)]="condicionesFilterValue"
                    placeholder="Ej. rsi > 70" #condicionesSearchInput (blur)="closeCondicionesSearchIfEmpty()">
                </div>
              </div>
              <div class="table-container condiciones-wrapper indicadores-wrapper">
                <cdk-virtual-scroll-viewport #condicionesViewport [tvsItemSize]="24" [headerHeight]="34" class="tvs-viewport tableStyle">
                <table cdk-table [dataSource]="condicionesDataSource" class="table-striped tableStyle">
                  <!-- Checkbox Column -->
                  <ng-container cdkColumnDef="select">
                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header">
                      <mat-checkbox class="compact-checkbox" (change)="$event ? masterToggleCondiciones() : null"
                        [checked]="selectionCondiciones.hasValue() && isAllSelectedCondiciones()"
                        [indeterminate]="selectionCondiciones.hasValue() && !isAllSelectedCondiciones()">
                      </mat-checkbox>
                    </th>
                    <td cdk-cell *cdkCellDef="let row">
                      <mat-checkbox class="compact-checkbox" (click)="$event.stopPropagation()"
                        (change)="$event ? onToggleCondicion(row) : null"
                        [checked]="selectionCondiciones.isSelected(row)">
                      </mat-checkbox>
                    </td>
                  </ng-container>

                  <!-- Counter Column -->
                  <ng-container cdkColumnDef="index">
                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> # </th>
                    <td cdk-cell *cdkCellDef="let element; let i = index"> {{i + 1}} </td>
                  </ng-container>

                  <!-- Label Column -->
                  <ng-container cdkColumnDef="label">
                    <th cdk-header-cell *cdkHeaderCellDef class="sticky-header" (click)="sortCondiciones('label')">
                      Condición
                      <i class="material-icons align-middle ml-1" *ngIf="sortColumnCondiciones === 'label'">
                        {{sortDirectionCondiciones === 'asc' ? 'arrow_upward' : 'arrow_downward'}}
                      </i>
                    </th>
                    <td cdk-cell *cdkCellDef="let element"><span class="label-text" title="{{element.label}}">{{element.label}}</span></td>
                  </ng-container>


                  <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsCondiciones; sticky: true"></tr>
                  <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsCondiciones;"
                    (click)="selectionCondiciones.toggle(row)" (contextmenu)="onCondicionContextMenu($event, row)"
                    [class.selected-row]="selectionCondiciones.isSelected(row)" style="cursor: pointer;">
                  </tr>
                </table>
                </cdk-virtual-scroll-viewport>
              </div>
                <button *ngIf="selectionCondiciones.hasValue()" mat-raised-button color="primary"
                (click)="eliminarCondicionesSeleccionadas()"
                style="position:absolute; bottom:16px; right:16px; z-index:10; height:30px; line-height:30px;" class="txt-sm">
                <mat-icon class="icon-md" style="height:16px; width:16px; line-height:16px;">delete</mat-icon>
                Eliminar seleccionadas ({{selectionCondiciones.selected.length}})
              </button>
              </div>
            </mat-tab>

          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    </div>

  </div>
</div>
<div class="context-menu shadow-lg" #ctxMenu [style.left.px]="contextMenuX" [style.top.px]="contextMenuY"
  *ngIf="showContextMenu">
  <div class="context-menu-items">
    <button class="context-menu-item" (click)="onContextMenuGuardar()">
      <i class="material-icons">save</i>
      <span>Guardar en Diversificafor</span>
    </button>
    <button class="context-menu-item" (click)="onContextMenuGuardarEnIdeas()">
      <i class="material-icons">lightbulb</i>
      <span>Guardar condición en Ideas</span>
    </button>
    <button class="context-menu-item" (click)="onContextMenuMejoraFuerzaBruta()">
      <i class="material-icons">tune</i>
      <span>Mejora Fuerza bruta  (Añadir condición)</span>
    </button>
    <button class="context-menu-item" (click)="onContextMenuMejoraGenetica()">
      <i class="material-icons">tune</i>
      <span>Mejora Genetica (Añadir condición)</span>
    </button>
    <button class="context-menu-item" (click)="onContextMenuOptimizarModelo()">
      <i class="material-icons">tune</i>
      <span>Optimizar Modelo</span>
    </button>
  </div>
</div>

<div class="context-menu shadow-lg" #ctxMenu2 [style.left.px]="contextMenuX2" [style.top.px]="contextMenuY2"
  *ngIf="showContextMenu2">
  <div class="context-menu-items">
    <button class="context-menu-item" (click)="editarCondicion($event)">
      <i class="material-icons">edit</i>
      <span>Editar</span>
    </button>
    <button class="context-menu-item" (click)="eliminarCondicion($event)">
      <i class="material-icons">delete</i>
      <span>Eliminar</span>
    </button>
    <button class="context-menu-item" (click)="copiarCondicion($event)">
      <i class="material-icons">content_copy</i>
      <span>Copiar</span>
    </button>
    <!--button class="context-menu-item" (click)="cortarCondicion($event)">
      <i class="material-icons">content_cut</i>
      <span>Cortar</span>
    </button-->
    <button class="context-menu-item" [disabled]="!condicionCopiada" (click)="pegarCondicion()">
      <i class="material-icons">content_paste</i> <span>Pegar</span>
    </button>

  </div>
</div>